<template>
  <div class="city">
    <!-- <t-header></t-header> -->
    <t-list :cities="cities" @func="getMsgFormSon" :hotCities="hotCities"></t-list>
    <t-alphabet :cities="charList" v-show="clickType == 0"></t-alphabet>
  </div>
</template>

<script>
import tList from '../../components/tList'
import tAlphabet from '../../components/tAlphabet'
export default {
  name: 'City',
  data() {
    return {
      cities: [],
      hotCities: [],
      clickType:0,//tList父组件传来的值(等于0就显示右边的字母列表)
      charList: {'A':'A','B':'B','C':'C','D':'D','E':'E','F':'F','G':'G','H':'H','I':'I','J':'J','K':'K','L':'L','N':'N','M':'M','O':'O','P':'P','Q':'Q','R':'R','S':'S','T':'T','U':'U','V':'V','W':'W','X':'X','Y':'Y','Z':'Z'}
    }
  },
  components: {
    // tHeader,
    tList,
    tAlphabet
  },
  methods: {
    getCityInfo() {
      // getCitiesInfo().then(this.getCityInfoSucc)
    },
    // getCityInfoSucc(res) {
    //   if(res.data.ret && res.data){
        
    //     const cityInfo = res.data.data
    //     this.cities = cityInfo.cities
    //     this.hotCities = cityInfo.hotCities
    //   }
    // },

    // 获取绑定的学员
    getBindStudent(){
        this.$http.getBindStudent({
            type:0
        }).then(res=>{
            if(res.status == 1){
                this.cities = res.data
            }
        })
    },
    // 子传父
    getMsgFormSon(data){
      this.clickType = data
    }
  },
  mounted() {
    // this.getCityInfo()
  },
  created(){
    this.getBindStudent()
  },
}
</script>
